import React from 'react';
import type { MotTest } from '../types/motHistory.types';
import { MotTestRow } from './MotTestRow';

interface MotTestListProps {
  tests: MotTest[];
}

export const MotTestList: React.FC<MotTestListProps> = ({ tests }) => {
  if (tests.length === 0) {
    return <p className="text-sm text-mp-muted italic">No MOT tests recorded</p>;
  }

  const sorted = [...tests].sort((a, b) =>
    b.completed_date.localeCompare(a.completed_date)
  );

  return (
    <div className="space-y-2">
      {sorted.map((test, i) => (
        <MotTestRow key={`${test.completed_date}-${i}`} test={test} />
      ))}
    </div>
  );
};
